export default __webpack_public_path__ + "static/media/mastercard.6c96740a.svg";